import { render } from "./DeactivatedTopics.vue?vue&type=template&id=1eedac0d"
import script from "./DeactivatedTopics.vue?vue&type=script&lang=js"
export * from "./DeactivatedTopics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__